var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-t m-b",class:_vm.active ? 'active' : 'inactive'},[_c('div',{staticClass:"line-height-15"},[_vm._v(_vm._s(_vm.status))]),_c('div',{staticClass:"line-height-15 font-sm"},[_vm._v(_vm._s(_vm.phase))])])}
var staticRenderFns = []

export { render, staticRenderFns }